import React from "react";
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  SimpleForm,
  TextInput
} from "admin-on-rest";
import RichTextInput from "aor-rich-text-input";
import IconTitle from "../components/icon_title";

export const StaticList = props => (
  <List
    {...props}
    title={<IconTitle icon="pages" title={"resources.static.title"} />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="slug" />
      <EditButton />
    </Datagrid>
  </List>
);

const toolbar = [
  [{ header: [1, 2, 3] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  ["image", "code-block"]
];

export const StaticEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="slug" />
      <RichTextInput source="body" toolbar={toolbar} />
    </SimpleForm>
  </Edit>
);

export const StaticCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="slug" />
      <RichTextInput source="body" toolbar={toolbar} />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/static/index.js